if (!customElements.get('product-list-slider')) {
  class ProductListSlider extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      if (typeof Swiper === 'undefined') return;
      this.sliderPrev = this.querySelector('.swiper-button-next');
      this.sliderNext = this.querySelector('.swiper-button-prev');
      this.swiper = new Swiper(this, {
        loop: false,
        spaceBetween: 24,
        navigation: {
          nextEl: this.sliderPrev,
          prevEl: this.sliderNext,
        },
        breakpoints: {
          990: {
            slidesPerView: 4,
          },
          750: {
            slidesPerView: 3,
            spaceBetween: 12,
          },
          0: {
            slidesPerView: 2,
            spaceBetween: 5,
          },
        },
      });
    }
  }
  customElements.define('product-list-slider', ProductListSlider);
}